import { mapperModuleMedia, mapperModuleNavigationLink } from '../../../../core/data-layer/modules/mappers'
import type { MapperOptions, ModuleMedia } from '#layers/core/types'

export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  return {
    id: data.sys?.id || '',
    title: data.title || '',
    text: data.text || '',
    estimatedRelease: data.estimatedRelease || '',
    tags: data.tags || [],
    isLocked: data.isLocked || false,
    image: mapperModuleMedia(data.image, options.imageOptions) as ModuleMedia,
    link: mapperModuleNavigationLink(data.link, options.getUrl)
  }
}
